import React from 'react';
import { Grid, CardContent, makeStyles } from '@material-ui/core';
import { useDevice } from 'components/DeviceContext.js';
import { Card1, Card2 } from 'components/Card';

const useStyles = makeStyles({
    root: {
        margin: '50% ',
        width: '100%',



    },
});
const cardsData = [

    {
        imageUrl: require('imagens/estudo-tecnico-fundos-dos-direitos-da-crianca.jpg'),
        alt: '',
        link: 'https://cnm.org.brstorage/biblioteca/Estudo_Fundos%20dos_Direitos_da_Crianca_e_do_Adolescente_no_Brasil_2019.pdf',
    },
    {
        imageUrl: require('imagens/Fundo-Municipal-Guia-para-Acao-Passo-a-Passo-1.jpg'),
        alt: '',
        link: require('Documentos/Fundo-Municipal_Guia-para-Acao-Passo-a-Passo.pdf'),
    },
    {
        imageUrl: require('imagens/Fundo-Municipal_Guia-para-Mobilizacao-de-Recurso.jpg'),
        alt: '',
        link: require('Documentos/Fundo-Municipal_Guia-para-Mobilizacao-de-Recurso.pdf'),
    },
    {
        imageUrl: require('imagens/nota-tecnica-19-2017.jpg'),
        alt: '',
        link: 'https://cnm.org.br/storage/biblioteca/NT_19_2017_FIA.pdf',
    },

];

const Cards = () => {
    const classes = useStyles();
    const { isMobile, isLaptop } = useDevice();

    return (
        <Grid container style={{ display: 'flex', justifyContent: 'space-around', padding: '0.5em', }}>
            <Grid item xs={12} md={6} lg={5} style={{ display: 'flex', width: isMobile ? '10px' : isLaptop ? '80%' : '100px', flexWrap: 'wrap', textAlign: isMobile ? 'center' : 'left' }}>
                <p style={{ color: 'var(--azul-vivido)', fontSize: '30px', fontWeight: '400' }}>Material Técnico</p>
                <p style={{ color: 'var(--laranja)', fontSize: isMobile ? '20px' : '25px', fontWeight: '20' }}>A CNM disponibiliza abaixo algumas publicações referentes a Campanha do Fundo da Infância e Adolescência</p>
                {cardsData.map((card, index) => (
                    <a key={index} href={card.link} target="_blank" rel="noopener noreferrer">
                        <CardContent className={classes.cardContent}>
                            <img alt="" src={card.imageUrl} style={{ width: isMobile ? '150px' : isLaptop ? '200px' : '300px' }} />

                        </CardContent>
                    </a>
                ))}
            </Grid>
            <Grid item xs={12} md={5} lg={4} style={{ paddingTop: '2em' }}>
                <Card1 />
                <Card2 />
            </Grid>


        </Grid>
    );
};

export default Cards;
